import React, { Component } from 'react';
import Navbar from './Navbar';
import HeroScreen from './HeroScreen';
import AldeiaSection from './AldeiaSection';
import PontosInteresse from './pontos_interesse/PontosInteresse';
import Essencia from './Essencia';
import AquiPerto from './AquiPerto';
import Eventos from './eventos/Eventos.js';
import Noticias from './noticias/Noticias';
import Alojamento from './Alojamento';
import Restaurantes from './restaurantes/Restaurantes';
import NewRestaurantes from './restaurantes/NewRestaurantes'
import Lojas from './Lojas';
import Comunidade from './comunidade/Comunidade';
import Contacts from './contacts/Contacts';
import Footer from '../header_footer/footer/Footer';

import './landingPage.css';

const divWidth = {
  width: '90%',
  margin: '0 auto'
}

export class Separator extends Component {
  render() {
    return (
      <div style={divWidth}>
      <div className="separator">
      </div>
      </div>
    )
  }
}


export default class LandingPage extends Component {
  render() {
    return (
      <div>
        <HeroScreen></HeroScreen>
        <Navbar></Navbar>
        <AldeiaSection></AldeiaSection>
        <PontosInteresse></PontosInteresse>
        <Essencia></Essencia>
        <AquiPerto></AquiPerto>
        <Eventos></Eventos>
        <Noticias></Noticias>
        <Alojamento></Alojamento>
        <NewRestaurantes></NewRestaurantes>
        <Lojas></Lojas>
        <Comunidade></Comunidade>
        <Contacts></Contacts>
        <Footer></Footer>
      </div>
    )
  }
}
